import { render, staticRenderFns } from "./cardEducaciones.vue?vue&type=template&id=ae48c6da"
import script from "./cardEducaciones.vue?vue&type=script&lang=js"
export * from "./cardEducaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports